import { render } from "./SmsCode.vue?vue&type=template&id=6a96f88e&scoped=true"
import script from "./SmsCode.vue?vue&type=script&lang=js"
export * from "./SmsCode.vue?vue&type=script&lang=js"

import "./SmsCode.vue?vue&type=style&index=0&id=6a96f88e&scoped=true&lang=stylus"

import exportComponent from "D:\\GameProject\\h5yaoji\\H5-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a96f88e"]])

export default __exports__